import {NgModule} from '@angular/core';
import {PrizesServiceProvider} from "./services/prizes-service/prizes-service";

@NgModule({
  providers: [
    PrizesServiceProvider
  ]
})
export class SellionsPrizesModule {}



// WEBPACK FOOTER //
// ./src/modules/prizes/prizes.module.ts